import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link2 } from "lucide-react";

const recommendations = {
  "Good Places to Eat": [
    { name: "Blue Moon Beach Grill", url: "bluemoonbeachgrill.com" },
    { name: "Bonzer Shack", url: "www.bonzershack.com" },
    { name: "Dare Devils Pizzeria", url: "www.daredevilspizzeria.com" },
    { name: "Food Dudes", url: "fooddudeskitchen.com" },
    { name: "Jack Brown's Burger Joint", url: "jackbrownsjoint.com" },
    { name: "JK's Steakhouse", url: "jksrestaurant.com" },
    { name: "Josephine's Sicilian Kitchen", url: "josephineskitchenobx.com" },
    { name: "Mama Kwan's Tiki Bar & Grill", url: "mamakwans.com" },
    { name: "Proof Bakery", url: "www.proof-obx.com" },
    { name: "Sal's New York Pizza", url: "Salsnypizzaobx.com" },
    { name: "Sam & Omie's Restaurant", url: "samandomies.net" },
    { name: "The SaltBox Café", url: "http://www.thesaltboxcafe.com" },
    { name: "Trio Restaurant & Market", url: "obxtrio.com" },
    { name: "Waveriders Coffee, Deli & Market", url: "waveridersobx.com" }
  ],
  "Convenience": [
    { name: "Starbucks", location: "Located at Mile Post 9" },
    { name: "CVS Pharmacy", location: "Located at Mile Post 9" },
    { name: "Walgreens", location: "Located at Mile Post 9" },
    { name: "Harris Teeter", location: "Located at Mile Post 9.5" },
    { name: "ABC Liquors", location: "Located at Mile Post 9.5" },
    { name: "Wawa", location: "Located at Mile Post 6" },
    { name: "Target", location: "Located at Mile Post 6" }
  ],
  "Suggested Local Attractions": [
    { name: "Wright Brothers National Memorial" },
    { name: "Avalon Pier" },
    { name: "Jennette's Pier" },
    { name: "Jockey's Ridge State Park" },
    { name: "Nags Head Woods Preserve" },
    { name: "Bodie Island Lighthouse" },
    { name: "Historic Manteo & Roanoke Island" },
    { name: "Currituck Beach Lighthouse" }
  ]
};

const LocalRecommendations = () => {
  return (
    <div className="container mx-auto py-16 px-4">
      <h2 className="text-4xl font-bold text-center mb-12">Local Recommendations from the Owners</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {Object.entries(recommendations).map(([category, items]) => (
          <Card key={category} className="fade-in">
            <CardHeader>
              <CardTitle className="text-2xl text-center text-primary">{category}</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3">
                {items.map((item, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <span className="w-2 h-2 bg-primary rounded-full mt-2" />
                    <div>
                      {'url' in item ? (
                        <a
                          href={item.url.startsWith('http') ? item.url : `https://${item.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary hover:underline"
                        >
                          {item.name}
                        </a>
                      ) : (
                        <span>{item.name}</span>
                      )}
                      {'location' in item && (
                        <span className="block text-sm text-muted-foreground">
                          {item.location}
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default LocalRecommendations;
